export const config = {
    nodeEnv: process.env.NODE_ENV,
    commonUrl: process.env.REACT_APP_COMMON_URL || 'https://dev.newcode.by',
    baseUrl: process.env.REACT_APP_BASE_URL || 'https://dev.newcode.by/api/crm',
};
